//
// MediaScheme.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../BIRDModel";
import "./BaseStylesheetResource";
import "./StylesheetFile";
import "./Stylesheet";

var MediaScheme = createModule("BIRD::MediaScheme", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        stylesheet: 1,
        baseStylesheetResource: 1,
        name: 7,
        label: 7,
        stylesheetFile: 1,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default MediaScheme;
